var path = 'scripts/views/components/advanced-search-checkbox-fields.html';
var html = "<div class=\"pts search-field-checkbox-fields\">\n    <label ng-repeat=\"field in $ctrl.fieldList\" class=\"checkbox-inline\">\n        <input\n                type=\"checkbox\"\n                value=\"{{field}}\"\n                ng-checked=\"$ctrl.isSelected(field)\"\n                ng-click=\"$ctrl.toggleSelection(field)\"\n        > {{ \"transactions.search.CheckboxFields.\"+field | translate }}\n    </label>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/advanced-search-checkbox-fields.html
// module id = 295
// module chunks = 0